import { useEffect, useState } from "react";
import { useApi } from "../contexts/ApiProvider";

export function useCmsTheme() {
  const api = useApi();
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    let isMounted = true;

    api.get("/api/cms/theme").then((response) => {
      if (!isMounted) return;
      if (response.success && response.theme) {
        setTheme(response.theme);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [api]);

  return theme;
}
